import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanToString' })
export class BooleanToStringPipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {boolean} value
     * @param {any[]} args
     * @returns {string}
     */
    transform(value: boolean, args: any[] = []): string {
        if (value != null) {
            return value === true ? 'Si' : 'No';
        }
        else { return null; }
    }
}
